import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {
    NatGetRoomToResidentAuthenticationKey,
} from '../roomToResident/repository/NatGetRoomToResidentAuthenticationKey'
import {AGREEMENT_TYPE, FIRST_LOGIN_REFERRER_ID, RESIDENT_USER_TYPE} from '../../../CodeMaster'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    ParagraphText,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    DisplayBlockDiv,
    DisplayItemInput,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitleRequired,
    FieldErrorLabel,
} from '../../../styledComponents/DisplayItem'
import {StyledButton, StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {BreakPoint, Colors, FontSize} from '../../../styledComponents/Constants'
import {DialogTitle as MuiDialogTitle, Tooltip, TooltipProps} from '@mui/material'
import {Messages} from '../../../Messages'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {StylesProvider} from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'
import {generateMedia} from 'styled-media-query'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {Location} from 'react-router-dom'

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    residentUserType: string
    authenticationKey: string
    dIspStepInfo: DIspStepInfo
    policyAgreeType: string
}

interface Props {
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location<FirstLoginLocationState>
}

interface States {
    authenticationKey: string
    nextButtonFlg: boolean
    errorAuthenticationKey: string
    fieldsError: Partial<FieldsError>,
    isLoadCompleted: boolean
    tooltipOpen: boolean
}

interface FieldsError {
    authenticationKey: Error
}

interface Error {
    message: string
    hasError: boolean
}

const HtmlTooltip = styled(({className, ...props}: TooltipProps) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(() => ({
    '& .MuiTooltip-tooltip': {
        backgroundColor: Colors.PrimaryVariant,
        color: Colors.Surface,
        maxWidth: 320,
        fontSize: FontSize.Small,
        border: '1px solid #dadde9',
        transform: 'none!important',
        bottom: -15,
        cursor: 'pointer',
        pointerEvents: 'auto' as const,
        padding: 0,
    },
    '& .MuiTooltip-arrow': {
        left: '50%!important',
        color: Colors.PrimaryVariant,
    },
}));
export {HtmlTooltip};


type Field = 'authenticationKey';

class NatResidentFirstLoginAuthenticationKeyInputPage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState
    queryToken: string

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
        this.state = {
            authenticationKey: '',
            nextButtonFlg: true,
            errorAuthenticationKey: '',
            fieldsError: {},
            isLoadCompleted: false,
            tooltipOpen: false,
        }
        const locationState = this.props.location.state
        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : []
        this.queryToken = getQueryParameter('token', this.props.location.search)

        this.backLoginButtonClick = this.backLoginButtonClick.bind(this)
        this.nextButtonClick = this.nextButtonClick.bind(this)
        this.nextButtonClick = this.nextButtonClick.bind(this)
    }

    componentDidMount(): void {
        if (this.firstLoginLocationState.policyAgreeType !== AGREEMENT_TYPE.SUTEKI_AND_HASOKO.value &&
            this.firstLoginLocationState.policyAgreeType !== AGREEMENT_TYPE.SUTEKI.value) {
            // 規約に同意していない場合、ログインへ遷移
            this.props.navigate(
                `/resident/login`,
            )
            return
        }

        const authenticationKey = this.firstLoginLocationState.authenticationKey ?? ''
        const nextButtonFlg = authenticationKey === ''
        this.setState({
            authenticationKey: authenticationKey,
            nextButtonFlg: nextButtonFlg,
            isLoadCompleted: true,
        })
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        let authenticationKey: string = this.state.authenticationKey
        let nextButtonFlg: boolean

        // 入力項目
        if (event.target.name === 'authenticationKey') {
            authenticationKey = event.target.value
        }

        // 活性/非活性　制御
        nextButtonFlg = authenticationKey === ''

        this.setState({
            nextButtonFlg: nextButtonFlg,
            authenticationKey: authenticationKey,
        })
    }


    // 次へ
    async nextButtonClick(): Promise<void> {
        await this.clearMessage()

        await this.props.eventEmitter.showLoading()
        try {
            // 認証キーチェック
            const authenticationKey: string = this.state.authenticationKey
            const roomToResidentInfo: Nullable<NatGetRoomToResidentAuthenticationKey> =
                await NatAsyncCallFunction(
                    this.props.roomToResidentRepo.getRoomToResidentByAuthenticationKey.bind(
                        this.props.roomToResidentRepo,
                        authenticationKey), this.props.navigate)

            if (!roomToResidentInfo || (roomToResidentInfo && roomToResidentInfo.details === null)) {
                this.setFieldErrorMessage('authenticationKey', Messages.ERESR0002.toString())
                return
            }

            let nextUrl: string = ''
            if (this.firstLoginLocationState.policyAgreeType === AGREEMENT_TYPE.SUTEKI_AND_HASOKO.value) {
                // 素敵ネット/長谷工ID 規約 同意の場合
                nextUrl = `/resident/firstLoginHasekoIdConfirm?token=${this.queryToken}`
            } else {
                // 素敵ネット 規約 同意の場合
                nextUrl = `/resident/firstLoginMailAddressRegister?token=${this.queryToken}`
            }

            // 引継ぎ情報
            this.firstLoginLocationState.firstLoginReferrerId = FIRST_LOGIN_REFERRER_ID.AUTHENTICATION_KEY_INPUT.value
            this.firstLoginLocationState.residentUserType = RESIDENT_USER_TYPE.MAIN.value
            this.firstLoginLocationState.authenticationKey = this.state.authenticationKey

            this.props.navigate(
                nextUrl,
                {state: {firstLoginLocationState: this.firstLoginLocationState}},
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(
            `/resident/login`,
        )
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string): void {
        this.setState(({fieldsError}) => (
            {
                fieldsError: {
                    ...fieldsError,
                    [field]: {
                        message: message,
                        hasError: true,
                    },
                },
            }))
    }

    // メッセージ取得（フィールド）
    getFieldErrorMessage(fieldId: Field): Nullable<ReactElement> {
        const field: Error | undefined = this.state.fieldsError[fieldId]
        if (field !== undefined) {
            return (
                <FieldErrorLabel>
                    {field.message}
                </FieldErrorLabel>
            )
        } else {
            return null
        }
    }

    // フィールドエラー状態取得
    getFieldErrorStatus(fieldId: Field): boolean {
        const field: Error | undefined = this.state.fieldsError[fieldId]
        return !!(field !== undefined && field.hasError)
    }

    // メッセージクリア
    clearMessage(): void {
        this.setState({fieldsError: {}})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.firstLoginLocationState.dIspStepInfo}
                    nowStep={Step.AUTHENTICATION_KEY}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        初回認証キー入力
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <WideMainContainer>
                    <BlockSpacer height={'15px'}/>
                    <ParagraphText>認証キーを入力してください。</ParagraphText>
                    <ParagraphText>２回目以降は登録いただいたメールアドレスとパスワードにてログインいただけますようお願いいたします。</ParagraphText>
                    <DisplayBlockFormFocus>
                        <DisplayItemInputTitleRequired>認証キー入力</DisplayItemInputTitleRequired>
                        <DisplayItemInputLabelRequired>

                            <StylesProvider injectFirst>
                                <HtmlTooltip
                                    open={this.state.tooltipOpen}
                                    onClose={() => this.setState({tooltipOpen: false})}
                                    disableHoverListener
                                    title={
                                        <TooltipWrapper>
                                            <StyledMuiDialogTitle>
                                                <SelectUserTitle>書面にてご案内している認証キーをご入力下さい</SelectUserTitle>
                                                <StyledCloseIcon fontSize={'small'}/>
                                            </StyledMuiDialogTitle>
                                        </TooltipWrapper>
                                    }
                                    arrow
                                    placement="top-end">
                                    <span>
                                    <DisplayItemInput
                                        type="text"
                                        name="authenticationKey"
                                        defaultValue={this.state.authenticationKey}
                                        maxLength={12}
                                        onFocus={() => {
                                            this.setState({tooltipOpen: true});
                                        }}
                                        onChange={this.handleInputChange.bind(this)}

                                        hasError={this.getFieldErrorStatus('authenticationKey')}
                                        autoFocus={true}
                                    />
                                </span>
                                </HtmlTooltip>
                            </StylesProvider>
                        </DisplayItemInputLabelRequired>
                        {this.getFieldErrorMessage('authenticationKey')}
                    </DisplayBlockFormFocus>
                    <BlockSpacer height={'5px'}/>
                </WideMainContainer>
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton
                    onClick={this.nextButtonClick.bind(this)}
                    disabled={this.state.nextButtonFlg}>
                    次へ進む
                </PrimaryStyledButton>
                <BlockSpacer height={'30px'}/>
                <CenterPlainLinkStyledButton onClick={this.backLoginButtonClick.bind(this)}>
                    ログイン画面へ戻る
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginAuthenticationKeyInputPage)

const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})


// フォームブロック（フォーカス）
const DisplayBlockFormFocus = styled(DisplayBlockDiv)`
  display: block;
  position: relative;
`

const TooltipWrapper: StyledButton = styled.button`
  background-color: ${Colors.PrimaryVariant};
  border-color: ${Colors.PrimaryVariant};
  border-style: solid;
  cursor: pointer;

  &:focus {
    outline: 0;
  }
`


const StyledMuiDialogTitle = styled(MuiDialogTitle)`
  &.MuiDialogTitle-root {
    padding: 0;
    font-size: ${FontSize.Small};
    color: ${Colors.Surface};
  }
`

const SelectUserTitle: StyledDiv = styled.div`
  font-size: ${FontSize.Small};
  fontFamily: 'Noto Sans JP,sans-serif';
  color: ${Colors.Surface};
  padding-right: 20px;

  ${breakPoint.lessThan('sp')`
     padding-right: 10px;
  `}
`

const StyledCloseIcon = styled(CloseIcon)`
  top: -1px;
  right: 1px;
  position: absolute;
  color: ${Colors.Surface};
`
